import store from "../../store";

// Service Imports
import {
  getSigningPdfFile,
  getSigningDetails,
  sendDocForSigningService,
} from "./revvSignService";

// Method Imports
import { parseSignerData } from "./revvSignMethods";

export const updateSignTagValues = payload => dispatch => {
  dispatch({
    type: "UPDATE_SIGN_TAG_VALUES",
    payload,
  });
};

export const getDocForSigning = (docID, signingHash) => async dispatch => {
  try {
    const details = await getSigningDetails(docID, signingHash);
    const pdfFile = await getSigningPdfFile(docID, signingHash);

    return Promise.all([pdfFile, details])
      .then(response => {
        dispatch({
          type: "FETCH_DOC_FOR_ESIGNING",
          payload: {
            data: parseSignerData(response[1]),
          },
        });
        return response[0];
      })
      .catch(error => {
        throw error;
      });
  } catch (error) {
    console.error(`revvSignActions => getDocForSigning => ${error}`);
    throw error;
  }
};

export const signAndFetchUpdatedData =
  (docID, signingHash, payload, view) => async dispatch => {
    try {
      const signTheDoc = await sendDocForSigningService(
        docID,
        signingHash,
        payload,
        view,
      );
      const details = await getSigningDetails(docID, signingHash);

      return Promise.all([signTheDoc, details])
        .then(response =>
          dispatch({
            type: "FETCH_DOC_AFTER_ESIGNING",
            payload: {
              data: parseSignerData(response[1]),
            },
          }),
        )
        .catch(error => {
          throw error;
        });
    } catch (error) {
      console.error(`revvSignActions => signAndFetchUpdatedData => ${error}`);
      throw error;
    }
  };

export const agreedToTerms = () => dispatch =>
  dispatch({
    type: "ON_AGREEMENT_TERM_ACCEPT",
  });

export const updateSignTagClick = id => dispatch => {
  if (id) {
    dispatch({
      type: "ON_SIGN_TAG_CLICK",
      payload: id,
    });
  }
};

export const updateSignTagValue = (id, value) => dispatch => {
  dispatch({
    type: "UPDATE_SIGN_TAG_VALUE",
    payload: { id, value },
  });
};

export const sendDocForSigning =
  (docID, signingHash, payload, view) => dispatch =>
    new Promise((resolve, reject) => {
      sendDocForSigningService(docID, signingHash, payload, view)
        .then(response => {
          dispatch({
            type: "SEND_FOR_ESIGN",
            payload: response,
          });
          resolve(response);
        })
        .catch(err => {
          reject(err);
        });
    });

export const updateSignerInfo = payload => dispatch =>
  dispatch({
    type: "UPDATE_DOC_SIGNER_INFO",
    payload,
  });

export const updateSignerTagactiveIndex = index => dispatch =>
  dispatch({
    type: "SET_ACTIVE_SIGNERTAG_INDEX",
    payload: index,
  });

export const updateDrawSignData = data => dispatch => {
  dispatch({
    type: "SET_DRAWSIGN_DATA",
    payload: data,
  });
};

export const resetDrawSignData = () => dispatch => {
  const reduxState = store.getState();
  const { data } = reduxState.RevvSignStore;
  const dataCopy = { ...data };
  Object.values(dataCopy).forEach(val => {
    delete val.isClicked;
    delete val.timestamp;
    delete val.isLastPosition;
  });
  dispatch({
    type: "RESET_DRAWSIGN_DATA",
    payload: dataCopy,
  });
};

export const toggleDrawsignPopup = (toggle, id, mode) => dispatch => {
  dispatch({
    type: "DRAWSIGN_POPUP_TOGGLE",
    payload: { toggle, id, mode },
  });
};
